import React from 'react';
import { Typography } from 'antd';
import { useNavigation } from '../context/NavigationContext';

const { Text } = Typography;

interface RecordLinkProps {
  recordId?: string | null;
  recordType?: string | null;
  projectId?: string | null;
}

// Shows a permanent record ID. Clickable when that record type has a register that can open it.
const RecordLink: React.FC<RecordLinkProps> = ({ recordId, recordType, projectId }) => {
  const { canOpenRecord, openRecord } = useNavigation();

  if (!recordId) return <Text type="secondary">—</Text>;

  if (!recordType || !canOpenRecord(recordType)) {
    return <Text strong style={{ color: '#1B2A4A' }}>{recordId}</Text>;
  }

  return (
    <Typography.Link strong onClick={() => openRecord({ recordId, recordType, projectId })}>
      {recordId}
    </Typography.Link>
  );
};

export default RecordLink;